import MuiTabs, { TabsProps as MuiTabsProps } from '@mui/material/Tabs';
import * as React from 'react';

export interface TabsProps extends MuiTabsProps {}

export const Tabs = (props: TabsProps) => {
  return <MuiTabs {...props} />;
};
